import React from 'react'

function SmallFooter() {
    return (
        <>
            <div className="footer-content-copy ">
                <h6 style={{ color: "white", padding: "20px" }}>@Copyright 2024 Integrated Risk Insurance Brokers Limited All Rights Reserved</h6>
            </div>
        </>
    )
}

export default SmallFooter